/* eslint-disable no-unused-expressions */

// Reducer for topic filter actions
import * as f from '../classes/Filters'
import { CURRENT_FILTER, TLM_FILTER, PROGRAMMING_FILTER, OTHER_FILTER, GENRE_FILTER, MEDIA_TYPE_FILTER, BRAND_PREFERENCE, ANTICIPATION, ANTICIPATION_FILTER, DEMOGRAPHICS, FILTER_MODE_MENU } from '../constants/commons'
import TopicHelpers from '../classes/TopicHelpers'
import TopicPlanFilterHelpers from '../classes/TopicPlanFilterHelpers'
import * as TLM from '../constants/tlm'
import { MediaPrefrence } from '../classes/FilterHelpers'

// Logic to set filters array in the new store
export const setFilters = (state, action) => {
  const selectedFilters = getSelectedFilters(state, action)
  const currentFilters = getCurrentFilters(state, action, selectedFilters)
  return {
    ...state,
    selectedFilters: selectedFilters,
    finalAction: getFinalAction(action, selectedFilters),
    currentFilters: currentFilters,
    numFiltersApplied: getFiltersAppliedCount(selectedFilters, currentFilters),
    module: action.module,
    mode: action.mode,
    filterSelected: action.mode !== FILTER_MODE_MENU ? true : false,
    filterApplied: false
  }
}

const getSelectedFilters = (state, action) => {
  if (action.filterType !== CURRENT_FILTER && action.filters && action.module !== ANTICIPATION) {
    let filter = [ action.filters ]
    let mediaTypeFilter = []
    if (state.selectedFilters && state.selectedFilters[action.filterType]) {
      let exists = state.selectedFilters[action.filterType].find(f => TopicHelpers.equals(f, action.filters))
      if (exists) {
        filter = state.selectedFilters[action.filterType].filter(f => !TopicHelpers.equals(f, action.filters))
      } else {
        filter = [...state.selectedFilters[action.filterType], action.filters]
      }
    }
    if (action.filterType === PROGRAMMING_FILTER || action.filterType === GENRE_FILTER) {
      mediaTypeFilter.push(TopicPlanFilterHelpers.mediaTypeFilter(TLM.SHOW))
      if (action.filterType === PROGRAMMING_FILTER || action.filterType === GENRE_FILTER) {
        mediaTypeFilter.push(TopicPlanFilterHelpers.mediaTypeFilter(TLM.MOVIE))
      }
    }
    let threshold = filter.find(f => f.threshold)
    //If "Remove Network Content" is selected, then reset other filters and send this alone
    if (action.filterType === PROGRAMMING_FILTER && !threshold && filter.find(f => f.label.indexOf('Network Content') > -1) && TopicHelpers.equals(action.filters, TopicPlanFilterHelpers.programmingFilter('RemoveNetworkContent'))) {
      return {
        ...state.selectedFilters,
        [TLM_FILTER]: [],
        [action.filterType]: [TopicPlanFilterHelpers.programmingFilter('RemoveNetworkContent')]
      }
    }
    //If "Remove Network Content" is already selected, remove that if any other filter is selected
    if (state.selectedFilters && state.selectedFilters[PROGRAMMING_FILTER]) {
      if (state.selectedFilters[PROGRAMMING_FILTER].find(f => f.label && f.label.indexOf('Network Content') > -1)) {
        return {
          ...state.selectedFilters,
          [PROGRAMMING_FILTER]: state.selectedFilters[PROGRAMMING_FILTER].filter(f => !TopicHelpers.equals(f, TopicPlanFilterHelpers.programmingFilter('RemoveNetworkContent'))),
          [action.filterType]: filter
        }
      }
    }

    // Brand Filters should work on top of the Brand Entity Filter. If all brand TLM filters are unselected, default to Brand Filter
    if (action.filterType === TLM_FILTER && action.module === BRAND_PREFERENCE && filter.length === 0) {
      mediaTypeFilter.push(TopicPlanFilterHelpers.mediaTypeFilter(TLM.BRAND))
    }

    return {
      ...state.selectedFilters,
      [action.filterType]: filter,
      [MEDIA_TYPE_FILTER]: mediaTypeFilter
    }
  }

  if (action.module === ANTICIPATION) {
    let filter = action.filterType === TLM_FILTER || action.filterType === GENRE_FILTER ? [ action.filters ] : action.filters
    if (state.selectedFilters && state.selectedFilters[action.filterType] && (action.filterType === TLM_FILTER || action.filterType === GENRE_FILTER)) {
      let exists = state.selectedFilters[action.filterType].find(f => TopicHelpers.equals(f, action.filters))
      if (exists) {
        filter = state.selectedFilters[action.filterType].filter(f => !TopicHelpers.equals(f, action.filters))
      } else {
        filter = [...state.selectedFilters[action.filterType], action.filters]
      }
    }
    return {
      ...state.selectedFilters,
      [action.filterType]: filter
    }
  }
}

const getFinalAction = (action, selectedFilters) => {
  if (action.filterType !== CURRENT_FILTER) {
    let filterArray = getFilterArray(action, selectedFilters)
    if (filterArray.length > 1) {
      return TLM.AND
    } else {
      return TLM.OR
    }
  }
}

const getFiltersAppliedCount = (selectedFilters, currentFilters) => {
  let count = 0
  if (selectedFilters) {
    Object.keys(selectedFilters).forEach((key) => {
      if (selectedFilters[key].length > 0) {
        count = count + selectedFilters[key].length
      }
    })
  } else if (currentFilters) {
    // Not removing this, may need in future
    const currentFilter = currentFilters['_filters']
    if (currentFilter && currentFilter.length > 0 && currentFilter.length < 9) {
      //count = currentFilter.length
    }
  }
  return count
}

const getFilterArray = (action, selectedFilters) => {
  let filterArray = []
  if (selectedFilters) {
    Object.keys(selectedFilters).forEach((key) => {
      if (selectedFilters[key].length > 0) {
        filterArray.push(key)
      }
    })
  }
  if (action.module === DEMOGRAPHICS && filterArray.length === 0) {
    filterArray.push('otherFilters')
  }
  return filterArray
}


const getCombinedFilters = (action, selectedFilters, filterArray) => {
  // If only one filter type selected e.g.  TLM or Programming either one || If multiple filters selected other than TLM, applying all the filters to tlm
  let filters = new f.Filters([])
  let linearNOT = []
  let threshold = undefined
  let dateRange = undefined
  let topicNameMatch = undefined

  //Don't to apply mediaTypeFilters if genre/programming filter is selected, apply only if it is unselected
  if ((filterArray.indexOf(PROGRAMMING_FILTER) > -1 && selectedFilters[PROGRAMMING_FILTER].length > 0)
  || (filterArray.indexOf(GENRE_FILTER) > -1) && selectedFilters[GENRE_FILTER].length > 0) {
    filterArray = filterArray.filter(f => f !== MEDIA_TYPE_FILTER)
  }

  filterArray.forEach((type) => {
    if (type === OTHER_FILTER) {
      selectedFilters[type].forEach((filter) => {
        threshold = filter.threshold ? filter.threshold : undefined
        dateRange = filter.date_range ? filter.date_range : dateRange
        topicNameMatch = filter.topic_name_match ? filter.topic_name_match : topicNameMatch
      })
    }
    selectedFilters[type].forEach((filter) => {
      if (filter.subType) {
         filter.subType.forEach((type) => {
          filters.filters.push(new f.Filter({
            topic_sub_type: type,
            labels_or: filter.defaultAction === TLM.OR ? filter.label : undefined,
            labels_and: filter.defaultAction === TLM.AND ? filter.label : undefined,
            labels_not: filter.defaultAction === TLM.NOT ? filter.label : undefined
           }))
          if (type === TLM.SHOW && filter.defaultAction === TLM.NOT) {
            filter.label.forEach(f => linearNOT.push(f))
          }
        })
      }

      if (action.mode === 'Active Content') {
        selectedFilters[type].forEach((filter) => {
          if (filter && filter.length > 0) {
            filter.forEach((fltr) => {
              if (fltr.subType) {
                fltr.subType.forEach((type) => {
                filters.filters.push(new f.Filter({
                  topic_sub_type: type,
                  labels_or: fltr.defaultAction === TLM.OR ? fltr.label : undefined,
                  labels_and: fltr.defaultAction === TLM.AND ? fltr.label : undefined,
                  labels_not: fltr.defaultAction === TLM.NOT ? fltr.label : undefined,
                  date_range: fltr.date_range ? fltr.date_range : dateRange
                  }))
              })
            }
          })
        }
      })
    }})
  })

  //Applying Other Filters
  if (action.mode !== 'Active Content') {
    let newFilters = new f.Filters([])
    filters.filters.forEach(filter => {
      let fltr = new f.Filter(filter)
      filters = filters.remove(filter)
      fltr.threshold = threshold ? threshold : undefined
      fltr.date_range = (filter.topic_sub_type === TLM.SHOW || filter.topic_sub_type === TLM.MOVIE) ? dateRange : undefined,
      fltr.topic_name_match = filter.topic_sub_type === TLM.VIDEO? topicNameMatch : undefined
      newFilters = newFilters.add(fltr)
    })
    filters = newFilters
  }

  if (filterArray.indexOf(PROGRAMMING_FILTER) > -1) {
    let notFilters = new f.Filters([])
    filters.filters.forEach(filter => {
      let newFilter = new f.Filter(filter)
      filters = filters.remove(filter)
      if (newFilter.labels_or || newFilter.labels_and) {
        newFilter.labels_not = linearNOT.length > 0 ? linearNOT : undefined
      }
      if ((newFilter.labels_or && newFilter.labels_not) || (newFilter.labels_and && newFilter.labels_not)) {
        filters = filters.add(newFilter)
      } else {
        notFilters = notFilters.add(newFilter)
      }
    })
    if (filters.filters.length <= 0 && notFilters.filters.length > 0) {
      filters = notFilters
    }
  }
  if (action.module === DEMOGRAPHICS && filters.filters.length === 0) {
    return new f.Filters([new f.Filter({
      topic_sub_type: TLM.LIFESTYLE
    })])
  }
  return filters
}

const getAnticipationFilters = (state, action, selectedFilters) => {
  const filterArray = getFilterArray(action, selectedFilters)
  let filters = selectedFilters[ANTICIPATION_FILTER]
  let labels = []
  if (filterArray.indexOf(GENRE_FILTER) > -1) {
    selectedFilters[GENRE_FILTER].length > 0 && selectedFilters[GENRE_FILTER].forEach(genre => {
      genre.label.forEach(l => labels.push(l))
    })
  }
  if (labels.length > 0) {
    filters && filters.filters.forEach(filter => {
      labels.forEach(label => {
        let newFilter = new f.Filter(filter)
        filters = filters.remove(filter)
        newFilter.labels_or = [label]
        filters = filters.add(newFilter)
      })
    })
  }
  return filters ? filters : new f.Filters([])
}

const getBrandFilters = (state, action, selectedFilters) => {
  const filterArray = getFilterArray(action, selectedFilters)
  let filter = selectedFilters[TLM_FILTER] ? selectedFilters[TLM_FILTER] : selectedFilters[OTHER_FILTER]
  let filters = new f.Filters([])
  let threshold = null
  if (filter) {
    if (filterArray.indexOf(OTHER_FILTER) > -1) {
      selectedFilters[OTHER_FILTER].length > 0 && selectedFilters[OTHER_FILTER].forEach(f => {
        threshold = f.threshold
      })
    }
    filter.forEach((filter) => {
      if (filter.label) { // Condition to restrict Brand to work with TLMs on top of Brand
        filters.filters.push(new f.Filter({
          topic_sub_type: TLM.BRAND,
          labels_or: filter.label,
          threshold: threshold ? threshold : undefined
        }))
      }
    })
    if (filters.filters.length === 0) {
      filters.filters.push(new f.Filter({
        topic_sub_type: TLM.BRAND,
        threshold: threshold ? threshold : undefined
      }))
    }
  }
  return filters ? filters : new f.Filters([])
}

// returns final filter array to perform client/server side filtering
const getCurrentFilters = (state, action, selectedFilters) => {
  if (action.filterType === CURRENT_FILTER) {
    return action.filters
  } else if ((action.filterType === ANTICIPATION_FILTER || action.filterType === GENRE_FILTER) && action.module === ANTICIPATION) {
    return getAnticipationFilters (state, action, selectedFilters)
  } else if (action.module === BRAND_PREFERENCE) {
    return getBrandFilters (state, action, selectedFilters)
  } else {
    let filterArray = getFilterArray(action, selectedFilters)
    if (filterArray.length === 1 || (filterArray.length > 0 && filterArray.indexOf(TLM_FILTER) < 0)) {
      // If only one filter type selected e.g.  TLM or Programming either one || If multiple filters selected other than TLM, applying all the filters to tlm

      return getCombinedFilters (action, selectedFilters, filterArray)
    }
    else if (filterArray.length > 1 && filterArray.indexOf(TLM_FILTER) > -1) {
      let tlmPresent = filterArray.indexOf(TLM_FILTER) > -1
      let filters = new f.Filters([])
      // If multiple filters selected along wiht TLM, applying all the filters to tlm
      if (tlmPresent) {
        let linearAND = []
        let linearNOT = []
        let threshold = undefined
        let dateRange = undefined
        let topicNameMatch = undefined
        filterArray.forEach((type) => {
          if (type !== TLM_FILTER) {
            let thresholdFilter = selectedFilters[type].find(f => f.threshold) // If Remove Bottom Quintile filter selected
            selectedFilters[type].forEach((l) => {
              if (!thresholdFilter && l.subType && l.subType.indexOf(TLM.SHOW) > -1 && (l.defaultAction === TLM.OR || l.defaultAction === TLM.AND)) {
                l.label && l.label.forEach(f => linearAND.push(f))
              }
              if (!thresholdFilter && l.subType && l.subType.indexOf(TLM.SHOW) > -1 && l.defaultAction === TLM.NOT) {
                l.label && l.label.forEach(f => linearNOT.push(f))
              }
              threshold = l.threshold ? l.threshold : undefined
              dateRange = l.date_range ? l.date_range : dateRange
              topicNameMatch = l.topic_name_match ? l.topic_name_match : topicNameMatch
            })
          }
        })
        let currentFilter = selectedFilters[TLM_FILTER]
        currentFilter.forEach((filter) => {
          filter && filter.subType && filter.subType.forEach((type) => {
            let labelsAnd = type === TLM.SHOW || type === TLM.MOVIE ? [ ...linearAND] : []
            if ((type === TLM.SHOW || type === TLM.MOVIE) && filter.label) {
              filter.label.forEach(f => labelsAnd.push(f))
            }
            filters.filters.push(new f.Filter({
              topic_sub_type: type,
              labels_and: (type === TLM.SHOW || type === TLM.MOVIE) && labelsAnd.length > 0 ? labelsAnd : undefined,
              labels_not: (type === TLM.SHOW || type === TLM.MOVIE) && linearNOT.length > 0 ? linearNOT : undefined,
              threshold: threshold ? threshold : undefined,
              date_range: (type === TLM.SHOW || type === TLM.MOVIE) ? dateRange : undefined,
              topic_name_match: type === TLM.VIDEO ? topicNameMatch : undefined
            }))
          })
        })
        // Adding Movie in the the filter if 'Remove Bottom Quintile' filter selected
        // if (threshold && filters.filters.find(e => e.threshold && e.type !== TLM.MOVIE)) {
        //   filters.filters.push(new f.Filter({
        //     topic_sub_type: TLM.MOVIE,
        //     threshold: threshold
        //   }))
        // }
      }
      return filters
    }
  }

  return MediaPrefrence
}
